import { initLocalOptionsWithDefaultOption } from '../Selectors/Option';

export const roofWindowTypes = initLocalOptionsWithDefaultOption([
  {
    value: 'no_roof_window',
    identifier: 'no_roof_window',
    externalIdentifier: 'no_roof_window',
  },
  {
    value: 'dome_window',
    title: 'Lichtkuppel',
    identifier: 'dome_window',
    externalIdentifier: 'domelight',
  },
  {
    value: 'dome_window',
    title: 'Rauchwarenanlage (RWA)',
    identifier: 'dome_window',
    externalIdentifier: 'rwa',
  },
]);

export const defaultRoofWindowType = roofWindowTypes[0];
export const noRoofWindowType = roofWindowTypes[0];

export function isRidgeLightBand(value) {
  return value === 'ridge_light_band';
}
